import { render, staticRenderFns } from "./signfor.vue?vue&type=template&id=b426a34e&scoped=true&"
import script from "./signfor.vue?vue&type=script&lang=js&"
export * from "./signfor.vue?vue&type=script&lang=js&"
import style0 from "./signfor.vue?vue&type=style&index=0&id=b426a34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b426a34e",
  null
  
)

export default component.exports